jQuery(document).ready(function ($) {
    const properties_views = $('.properties-views');
    const tabs = properties_views.find('.properties-views__tab');
    const views = properties_views.find('.properties-views__container').children();

    const toggles = properties_views.find('.properties-views__sort--dropdown').find('.toggle');

    $.fn.toggleTabs = function () {
        const all_tabs = this.parent().children();

        all_tabs.removeAttr('data-active');
        this.attr('data-active', '');

        const all_views = this.parent().parent().next().children();
        const view_to_open = this.parent().parent().next().find(`[data-view="${this.attr('data-view')}"]`);

        all_views.removeAttr('data-active').hide();
        view_to_open.attr('data-active', '').show();

        return this;
    }

    tabs.on('click', function (event) {
        event.preventDefault();

        $(this).toggleTabs();
    });

    toggles.on('click', function (event) {
        event.preventDefault();
    })
});